import jwtDecode from "jwt-decode";
import { TTree } from "src/app/main/pages/admin/indicators/indicators.component";

export function getDecodedAccessToken(): any {
  try {
    let token = ''
    token += localStorage.getItem('id_token')
    return jwtDecode(token)
  } catch(Error) {
    return '';
  }
}



export const arrayToTree = <T>(
  list: T[],
  { id, parentId }: { id: string; parentId: string }
): TTree<T>[] | [] => {
  /** map between id and array position */
  const map: number[] = [];
  const treeList: TTree<T>[] = list as TTree<T>[];

  for (let i = 0; i < treeList.length; i += 1) {
    /** initialize the map */
    map[(treeList[i] as TTree<T> & { [id: string]: number })[id]] = i;
    /** initialize the children */
    treeList[i].childs = [];
  }

  let node: TTree<T> & { [parentId: string]: number };
  /** return value */
  const roots: TTree<T>[] = [];

  for (const item of treeList) {
    node = item as TTree<T> & { [parentId: string]: number };
    if (node[parentId] !== null && node[parentId] !== 0) {
      if (treeList[map[node[parentId]]] !== undefined) {
        treeList[map[node[parentId]]].childs?.push(node);
      }
    } else {
      roots.push(node);
    }
  }
  return roots;

};

export function decodeAccessToken(token:string): any {
  try {
    return jwtDecode(token)
  } catch(Error) {
    return '';
  }
}

export function deepCopy<T>(source: T): T {
  return Array.isArray(source)
  ? source.map(item => deepCopy(item))
  : source instanceof Date
  ? new Date(source.getTime())
  : source && typeof source === 'object'
        ? Object.getOwnPropertyNames(source).reduce((o, prop) => {
           Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop)!);
           o[prop] = deepCopy((source as { [key: string]: any })[prop]);
           return o;
        }, Object.create(Object.getPrototypeOf(source)))
  : source as T;
}

export function updateObjectValues(originalObject: any, newValuesObject: any): any {
  // Loop over each property in the new values object
  Object.keys(newValuesObject).forEach(key => {
    // If the new values object has a property with the same name as the current key,
    // and its value is an object, then recursively call this function with the nested objects
    if (newValuesObject[key] !== null && typeof newValuesObject[key] === 'object' && !Array.isArray(newValuesObject[key])) {
      originalObject[key] = updateObjectValues(originalObject[key], newValuesObject[key]);
    }
    // If the original object has a property with the same name as the current key,
    // and its value is not an object or an array, update its value to the value of the new values object
    else if (originalObject.hasOwnProperty(key) && !Array.isArray(originalObject[key])) {
      originalObject[key] = newValuesObject[key];
    }
    // If the original object has a property with the same name as the current key,
    // and its value is an array, replace the original array with the new array
    else if (originalObject.hasOwnProperty(key) && Array.isArray(originalObject[key])) {
      originalObject[key] = newValuesObject[key];
    }
  });

  // Return the updated original object
  return originalObject;
}

export function getTimeAgo(date: Date) {
  //get time difference in seconds, minutes, hours, days, months, years
  let date2 = new Date(date)
  let seconds = Math.floor((new Date().getTime() - date2.getTime()) / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  let days = Math.floor(hours / 24);
  let months = Math.floor(days / 30);
  let years = Math.floor(months / 12);

  //return time ago
  if (seconds < 60) {
    return 'just now';
  }
  else if (minutes < 60) {
    if(minutes === 1) {
      return 'a minute ago';
    }
    return minutes + ' minutes ago';
  }
  else if (hours < 24) {
    if(hours === 1) {
      return 'an hour ago';
    }
    return hours + ' hours ago';
  }
  else if (days < 30) {
    if (days === 1) {
      return 'yesterday';
    }
    return days + ' days ago';
  }
  else if (months < 12) {
    if (months === 1) {
      return 'a month ago';
    }
    return months + ' months ago';
  }
  else if (years === 1) {
    return 'a year ago';
  }
  return years + ' years ago';
}

//function that return current web url without path
export function getWebUrl() {
  let url = window.location.href;
  let path = window.location.pathname;
  return url.replace(path, '');
}
